import type { ReactNode } from 'react';
import { Body1Strong, Caption1, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: tokens.colorNeutralBackground1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
    padding: tokens.spacingHorizontalL,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground2,
  },
  titleBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
    minWidth: 0,
  },
  subtitle: {
    color: tokens.colorNeutralForeground3,
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
    padding: tokens.spacingHorizontalL,
  },
  contentNoPadding: {
    flex: 1,
    height: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
});

interface AppLayoutProps {
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  noPadding?: boolean;
  children: ReactNode;
}

export function AppLayout({ title, subtitle, actions, noPadding, children }: AppLayoutProps) {
  const styles = useStyles();

  const hasHeader = title || actions;

  return (
    <div className={styles.root}>
      {hasHeader && (
        <div className={styles.header}>
          {title && (
            <div className={styles.titleBlock}>
              <Body1Strong>{title}</Body1Strong>
              {subtitle ? <Caption1 className={styles.subtitle}>{subtitle}</Caption1> : null}
            </div>
          )}
          {actions}
        </div>
      )}
      <div className={noPadding ? styles.contentNoPadding : styles.content}>{children}</div>
    </div>
  );
}
